function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "diagnosis");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "25.3423192%",
  y1: "13.1795998%",
  x2: "83.7201273%",
  y2: "87.6451387%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#223354",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3F6296",
  offset: "100%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "diagnosis",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.308890, 0.250000)",
  fill: "url(#linearGradient-1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.6911104,0 L12.6316824,1.6203265 L15.0635293,0.92938633 L16.1772839,3.19892998 L18.6799172,3.55684598 L18.7742761,6.08318208 L20.9149679,7.42806731 L19.9736156,9.77436939 L21.3822208,11.873681 L19.5679256,13.6342521 L20.0008835,16.125 L17.6273536,16.9954214 L17.0098018,19.4469327 L14.4874421,19.2767006 L12.9261611,21.2650867 L10.6911104,20.0836358 L8.4560597,21.2650867 L6.89477867,19.2767006 L4.37241891,19.4469327 L3.7548672,16.9954214 L1.38133728,16.125 L1.81429519,13.6342521 L-1.01307851e-13,11.873681 L1.40860517,9.77436939 L0.467252825,7.42806731 L2.60794463,6.08318208 L2.7023035,3.55684598 L5.20493688,3.19892998 L6.31869146,0.92938633 L8.75053837,1.6203265 L10.6911104,0 Z M9.57685423,6.63743809 C9.31241328,6.21254619 8.65529572,6.23452788 8.43585408,6.71650084 L8.43585408,6.71650084 L6.89811038,10.091 L4.62452499,10.0881602 L4.52846465,10.0950966 C4.21497151,10.1411593 3.97415049,10.4110569 3.97377197,10.7374068 C3.97335654,11.0963916 4.26403413,11.3877435 4.62301897,11.3881593 L4.62301897,11.3881593 L7.31682521,11.39128 L7.4111607,11.384528 C7.62778396,11.3530602 7.81668502,11.2137047 7.90914846,11.0106216 L7.90914846,11.0106216 L9.00111038,8.611 L11.5721085,14.7646785 L11.621194,14.860435 C11.8787413,15.2770737 12.5163907,15.2698609 12.7510645,14.8092148 L12.7510645,14.8092148 L14.4801104,11.414 L16.7651309,11.3912461 L16.8611056,11.3832114 C17.1740513,11.3335658 17.4117694,11.0609312 17.4084495,10.7345984 C17.404724,10.3756323 17.1107328,10.0876244 16.7517667,10.0913148 L16.7517667,10.0913148 L14.0732539,10.1188518 L13.9711013,10.1279773 C13.7704612,10.1620237 13.5949362,10.2889059 13.5007629,10.4737607 L13.5007629,10.4737607 L12.2301104,12.967 L9.62720719,6.73532148 Z",
  id: "Combined-Shape"
})));

var SvgDiagnosis = function SvgDiagnosis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDiagnosis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/diagnosis.0a04ea3b.svg";
export { ForwardRef as ReactComponent };